export class LanguageEs {

    vocabulary: {};

 constructor() {

    const vocabulary = {

      order_tt: 'Número de orden en este listado.',
      all_selected: 'Todos',
      all_selectedF: 'Todas',

      yes_tt: 'Si',
      not_tt: 'No',
      YES_tt: 'SI',
      NOT_tt: 'NO',

      // ----------------------
      // COMIENZO VS-CUT (main section "ms_")
      // ----------------------

      ms1_path_home: 'Inicio',
      ms2_path_home: 'Maestros',

      ms1: 'Entrada de datos',
      ms1_title: 'Página Principal',
      ms1_subtitle: 'Secciones',

      ms2: 'Parámetros generales',
      ms2_title: 'Datos Maestros',
      ms2_subtitle: 'Secciones',

      // ----------------------
      // TITULOS VS-CUT (section "st_")
      // ----------------------

      // Sección 1 => Entrada de Datos

      st1_path: 'Entrada datos',

      st1_button_optimizer: 'Cut Entrada',
      st1_button_optimizer_tt: 'Regenerar archivo de optimización',
      t1_button_download_optimizer: 'Descargar',
      st1_button_download_optimizer_tt: 'Descargar archivo de optimización',
      t1_button_copy_optimizer: 'Copiar a...',
      st1_button_copy_optimizer_tt: 'Copiar archivo de optimización a una ruta seleccionada.',
      t1_button_copy_table_optimizer: 'Copiar a mesa',
      st1_button_copy_table_optimizer_tt: 'Copiar archivo de optimización a una mesa especificada.',

      st1_title: 'Módulo Entrada Datos',
      st1_subtitle: 'Importación desde archivo',
      st1_actionInfo: '¿Desea generar el archivo de optimización en el siguiente directorio?',
      st1_actionOk: 'La acción se ha realizado correctamente.',

      st1_loadFile: 'Generar archivos',
      st1_modalFile: 'Añadir desde archivo',
      st1_modalFile_tt: 'Seleccione un archivo de su equipo:',
      st1_modalFile_ph: 'Añadir desde archivo',

      st1_modalFileButton: 'Piezas +',
      st1_modalFileButton_tt: 'Cargar desde archivo el listado de piezas que se quiere obtener.',
      st1_modalSheetButton: 'Hojas +',
      st1_modalSheetButton_tt: 'Cargar desde archivo el listado de planchas que se quiere usar.',

      st1_OptiButton: 'Optimizar',
      st1_OptiButton_tt: 'Lanzar los procesos de optimización.',
      st1_OptiButtonSave: 'Guardar',
      st1_OptiButtonSave_tt: 'Guardar la información de optimización para reflejarla en DIMPRO.',
      st1_OptiBlocks: 'Bloques',
      st1_OptiBlocks_tt: 'Usar bloques para agrupar piezas similares.',
      st1_OptiBase: 'Base.max',
      st1_OptiBase_tt: 'Preferencia en colocar las piezas sobre su mayor lado.',
      st1_OptiOrderSheet: 'Reordenar',
      st1_OptiOrderSheet_tt: 'Reordenar hojas según secuencias.',
      st1_OptiRotation: 'Rotar',
      st1_OptiRotation_tt: 'Forzar la rotación de la pieza.',
      st1_OptiInfoPiece: '+Info',
      st1_OptiInfoPiece_tt: 'Mostrar información detallada de la pieza.',
      st1_OptiSet: 'Encajar',
      st1_OptiSet_tt: 'Si siguiendo las condiciones la pieza no encaja, intenta colocarla probando otra posición.',
      st1_OptiTurn: 'Aproximar',
      st1_OptiTurn_tt: 'Girar para aproximar la pieza a un lado de la travera.',
      st1_OptiNear: 'Vertical',
      st1_OptiNear_tt: 'Aproximar la pieza al lado vertical / horizontal de la travera según valor.',
      st1_OptiDisband: 'Desbande',
      st1_OptiDisband_tt: 'Distancia de desbande para las hojas.',
      st1_OptiDiecutting: 'Min.Tronz',
      st1_OptiDiecutting_tt: 'Distancia mínima necesaria para el tronzado.',
      st1_OptiMaxDiecutting: 'Max.Trav.:',
      st1_OptiMaxDiecutting_tt: 'Distancia máxima de travera.',
      st1_OptiRetalWidth: 'Retal&nbsp;(ancho&nbsp;x&nbsp;alto):',
      st1_OptiRetalWidth_tt: 'Ancho mínimo que debe tener un sobrante para ser considerado "retal".',
      st1_OptiRetalHeight: 'Alto&nbsp;retal:',
      st1_OptiRetalHeight_tt: 'Alto mínimo que debe tener un sobrante para ser considerado "retal".',
      st1_OptiOrigin: 'Origen',
      st1_OptiOrigin_tt: 'Punto origen desde donde parte la optimización.',
      st1_OptiAxis: 'Eje',
      st1_OptiAxis_tt: 'Ejes usados en el corte.',
      st1_OptiZoom: 'Tam.',
      st1_OptiZoom_tt: 'Tamaño de la gráfica de la optimización.',
      st1_OptiFill: 'Color',
      st1_OptiFill_tt: 'Mostrar las piezas resaltadas en un color.',
      st1_OptiOrder: 'Tronzado:',
      st1_OptiOrder_tt: 'Mostrar el orden en que las piezas deberían ser tronzadas por los operarios.',
      st1_OptiFilename: '',
      st1_OptiFilename_tt: 'Nombre del archivo cargado.',
      st1_OptiFilename_ph: 'Seleccionar un archivo de entrada',

      st1_OptiMode: 'Modo:',
      st1_OptiMode_tt: 'Modo de optimización.',
      st1_OptiFree: 'Libertad:',
      st1_OptiFree_tt: 'Libertad en el tronzado de la plancha. Grupo de piezas que pueden estar esperando en mesa tronzadas.',
      st1_OptiGrade: 'Desorden:',
      st1_OptiGrade_tt: 'Número de pilas auxiliares que pueden apoyarse junto a cada caballete.',
      st1_OptiRep: 'Rep.:',
      st1_OptiRep_tt: 'Repetición máxima de piezas similares que violan una secuencia.',
      st1_OptiLevel: 'Nivel&nbsp;corte:',
      st1_OptiLevel_tt: 'Nivel de profundidad máximo para el corte de la optimización.',
      st1_OptiRute: 'Rutas:', // Detectar&nbsp;rutas:',
      st1_OptiRute_tt: 'Detectar rutas de trabajo de la planta.',
      st1_OptiOld: 'Recolocar',
      st1_OptiOld_tt: 'Aprovechar huecos de hojas anteriores para colocar piezas.',

      st1_OptiAreaD: 'Area&nbsp;Desbande:',
      st1_OptiAreaB: 'A.&nbsp;Bruta:',
      st1_OptiAreaS: 'Area&nbsp;Hojas:',
      st1_OptiAreaX: 'Merma:',
      st1_OptiAreaC: 'Pilas:',
      st1_OptiAreaT: 'A.&nbsp;Resto:',
      st1_OptiAreaR: 'A.&nbsp;Retal:',
      st1_OptiAreaP: 'A.&nbsp;Neta:',
      st1_OptiName: 'Optimización',
      st1_OptiSheet: 'Hojas:',
      st1_OptiEasel: 'Pilas:',
      st1_OptiNumSheet: 'Hojas&nbsp;usadas:',
      st1_OptiNumPiece: 'Nº&nbsp;Piezas:',
      st1_OptiAreaD_tt: 'Area total en m2 usada en el desbande.',
      st1_OptiAreaB_tt: 'Area total bruta en m2 de cristal usado.',
      st1_OptiAreaS_tt: 'Area total en m2 de todas las planchas usadas.',
      st1_OptiAreaX_tt: 'Porcentaje de merma.',
      st1_OptiAreaC_tt: 'Pilas obtenidas en los caballetes.',
      st1_OptiAreaT_tt: 'Area total en m2 de cristal desperdiciado.',
      st1_OptiAreaR_tt: 'Area total en m2 de cristal aprovechable para retales.',
      st1_OptiAreaP_tt: 'Area en m2 de todas las piezas optimizadas.',
      st1_OptiNumSheet_tt: 'Total de planchas consumidas.',

      st1_fieldName: 'Nombre',
      st1_fieldName_tt: 'Nombre del archivo',
      st1_fieldName_ph: 'Nombre del archivo',
      st1_fieldExist: 'Existe',
      st1_fieldExist_tt: 'Indica si existe ya un archivo optimizado.',
      st1_fieldDescription: 'Descripción',
      st1_fieldDescription_tt: 'Descripción del archivo de optimización',
      st1_fieldDescription_ph: 'Escriba una descripción para el archivo de optimización.',

      st1_fieldPath: 'Ruta del directorio',
      st1_fieldPath_tt: 'Ruta donde se encuentran los archivos a optimizar.',
      st1_fieldPath_ph: 'Introducir ruta => Ejemplo: ct211026/002/20206073',

      // Sección 1 Modal Detalle Archivo =>

      st1_modalDetailFile: 'Información sobre la optimización',
      st1_modalDetailFile_tt: 'Información de la optimización',
      st1_modalDetailFile_ph: 'Información de la optimización',

      st1_Sheet: 'Hoja',
      st1_fieldArchive: 'Archivo',
      st1_fieldTable: 'Mesa',
      st1_fieldDate: 'Fecha&nbsp;Prod',
      st1_fieldVidrio: 'Vidrio',
      st1_fieldId: 'Id.Vidrio',
      st1_fieldSheet: 'Planos',
      st1_fieldDimension: 'Medidas/Cant.',
      st1_fieldGroup: 'Grupo',
      st1_fieldLote: 'Lotes',
      st1_fieldCNC: 'CNC',
      st1_fieldArea: 'Area(m²)',
      st1_fieldAwastage: 'Merma(%)',
      st1_fieldCape: 'Capa',
      st1_fieldForm: 'Formas',
      st1_fieldHeight: 'Alto',
      st1_fieldWidth: 'Ancho',
      st1_fieldAmount: 'Cantidad',
      st1_fieldHRest: 'Alto hoja restante',
      st1_fieldWRest: 'Ancho hoja restante',
      st1_fielMaxSub: 'Máximo ancho subtravera',
      st1_fieldMinSub: 'Mínimo ancho subtravera',
      st1_fieldMinCut: 'Mínimo distancia corte',
      st1_fieldOptLimit: 'Sólo cortes Z',
      st1_fieldTrimcutDown: 'Trimcut abajo',
      st1_fieldTrimcutUp: 'Trimcut arriba',
      st1_fieldTrimcutRight: 'Trimcut derecha',
      st1_fieldTrimcutLeft: 'Trimcut izquierda',
      st1_fieldParams: 'Parámetros&nbsp;modificables',
      st1_fieldWheelWidth: 'Ancho&nbsp;muela&nbsp;(mm):',
      st1_fieldOverlap: 'Solapamiento&nbsp;(mm):',

      st1_fieldArchivo_tt: 'Nombre del archivo de optimización',
      st1_fieldTable_tt: 'Mesa de corte',
      st1_fieldDate_tt: 'Fecha de Producción',
      st1_fieldVidrio_tt: 'Nombre del Vidrio',
      st1_fieldId_tt: 'Identificador del Vidrio',
      st1_fieldSheet_tt: 'Planos de corte distintos',
      st1_fieldDimension_tt: 'Medidas y Cantidades',
      st1_fieldGroup_tt: 'Grupo',
      st1_fieldLote_tt: 'Lotes',
      st1_fieldArea_tt: 'Area neta total (m²)',
      st1_fieldAwastage_tt: 'Merma (%)',
      st1_fieldCape_tt: 'Capa',
      st1_fieldForm_tt: 'Formas',
      st1_fieldHeight_tt: 'Alto',
      st1_fieldWidth_tt: 'Ancho',
      st1_fieldAmount_tt: 'Cantidad',
      st1_fieldHRest_tt: 'Alto hoja restante',
      st1_fieldWRest_tt: 'Ancho hoja restante',
      st1_fielMaxSub_tt: 'Máximo ancho subtravera',
      st1_fieldMinSub_tt: 'Mínimo ancho subtravera',
      st1_fieldMinCut_tt: 'Mínimo distancia corte',
      st1_fieldOptLimit_tt: 'Sólo cortes Z',
      st1_fieldTrimcutDown_tt: 'Trimcut abajo',
      st1_fieldTrimcutUp_tt: 'Trimcut arriba',
      st1_fieldTrimcutRight_tt: 'Trimcut derecha',
      st1_fieldTrimcutLeft_tt: 'Trimcut izquierda',
      st1_fieldParams_tt: 'Apartado donde se listan los parámetros que permiten ser modificados.',
      st1_fieldWheelWidth_tt: 'Ancho de muela (mm):',
      st1_fieldOverlap_tt: 'Solapamiento (mm):',

      st1_fieldTSO: 'Archivo TSO (True Shape Optimizer) encontrado: No se puede generar archivo de optimización.',

      // Sección 1 Filtros Formulario =>
      st1_filterTable: 'Mesa',
      st1_filterTable_tt: 'Filtrar por mesa de corte',
      st1_filterTable_ph: 'Filtrar por mesa de corte',
      st1_filterVidrio: 'Vidrio',
      st1_filterVidrio_tt: 'Filtrar por vidrio',
      st1_filterVidrio_ph: 'Filtrar por vidrio',
      st1_filterDate: 'Fechas',
      st1_filterDate_tt: 'Filtrar por rango de fechas',
      st1_filterDate_ph: 'Filtrar por rango de fechas',

      // Sección 2 => PARÁMETROS GENERALES

      st2_title: 'Módulo Parámetros',
      st2_subtitle: 'Listado de parámetros',

      // ----------------------

      // -- Field Title
      fieldEmail_tt: 'Email',
      fieldAnnotation_tt: 'Anotación',
      fieldPostalcode_tt: 'Código Postal',
      fieldAddr1_tt: 'Dirección',
      fieldAddr2_tt: 'Dirección 2',
      fieldCity_tt: 'Ciudad',
      fieldProvince_tt: 'Provincia',
      fieldCountry_tt: 'País',
      fieldTel_tt: 'Teléfono',
      fieldDni_tt: 'DNI',

      // -- Field
      fieldEmail: 'Email',
      fieldAnnotation: 'Anotación',
      fieldPostalcode: 'Código Postal',
      fieldAddr1: 'Dirección',
      fieldAddr2: 'Dirección 2',
      fieldCity: 'Ciudad',
      fieldProvince: 'Provincia',
      fieldCountry: 'País',
      fieldTel: 'Teléfono',
      fieldDni: 'DNI',

      // ---- Field placeholder
      fieldEmail_ph: 'Email',
      fieldAnnotation_ph: 'Anotación',
      fieldPostalcode_ph: 'Código Postal',
      fieldAddr1_ph: 'Dirección',
      fieldAddr2_ph: 'Dirección 2',
      fieldCity_ph: 'Ciudad',
      fieldProvince_ph: 'Provincia',
      fieldCountry_ph: 'País',
      fieldTel_ph: 'Teléfono',
      fieldDni_ph: 'DNI',

      // ----------------------
      //   MESAS DE CORTE
      // ----------------------

      ms3: 'Mesas de corte',
      st3_title: 'Mesas',
      st3_subt1: 'Listado de mesas',
      st3_subt2: 'Edición de mesas',

      cuttingTableTitle: 'Módulo de Mesas',
      cuttingTableSubtitle: 'Listado de Mesas',
      cuttingTableEditSubtitle: 'Edición de Mesas de corte',

      modalCuttingTableEditInfo: '¿Desea modificar la mesa de corte?',
      modalCuttingTableDeleteInfo: '¿Desea eliminar la mesa de corte seleccionada?',
      modalTitleDeleteCuttingTable:  'Eliminar Mesa de corte',
      modalTitleEditCuttingTable:  'Editar Mesa de corte',


      addNewCuttingTable: 'Añadir nueva Mesa +',
      addCuttingTableModalHeader: 'Agregar nueva mesa',
      addCuttingTableButton: 'Agregar Mesa',
      deleteCuttingTableModal_tt: 'Eliminar Mesa',

      selectorMessage_r: 'Seleccione el tipo de mesa',
      alertCuttingTableName: 'Debe completar los datos del formulario',
      alertCuttingTableForm: ' El formulario no ha sido completado correctamente',

      st3_filterName: 'Nombre',
      st3_filterType: 'Tipo',

      st3_fieldName: 'Nombre',
      st3_fieldDescription: 'Descripción',
      st3_fieldType: 'Tipo',
      st3_fieldPath: 'Ruta',

      st3_fieldName_tt: 'Nombre de la mesa de corte',
      st3_fieldDescription_tt: 'Descripción de la mesa de corte',
      st3_fieldType_tt: 'Tipo de mesa de corte',
      st3_fieldPath_tt: 'Ruta de descarga para sus optimizaciones',

      st3_fieldName_ph: 'Introduzca el nombre de la mesa de corte',
      st3_fieldDescription_ph: 'Introduzca la descripción de la mesa de corte',
      st3_fieldType_ph: 'Introduzca el tipo de mesa de corte',
      st3_fieldPath_ph: 'Introduzca ruta de descarga',


      // ----------------------
      //      CABALLETES
      // ----------------------

      ms4: 'Caballetes',
      ms4_title: 'Datos Maestros',
      ms4_subtitle: 'Secciones',

      // ----------------------
      // FIN VS-CUT
      // ----------------------

      // ----------------------------------
      //  VS-CUT Menú Principal (mp)
      // ----------------------------------

      botonIniciarSesion: 'Inicie sesión',
      botonCerrarSesion: 'Cerrar sesión',
      selectIdiomaEs: 'Español',
      selectIdiomaEn: 'English',
      mpInicio: 'Inicio',
      mpMaestros: 'Maestros',
      mpOptimizador: 'Optimizaciones',
      mpProductividad: 'Productividad+',
      mpInformes: 'Informes',
      mpImpresion: 'Impresion',
      mpIdioma: 'Idioma',

      // ----------------------
      // BOTONES
      // ----------------------
      buttonSearch: 'Buscar',
      buttonSearch_tt: 'Buscar elementos',

      buttonFilter: 'Filtrar',
      buttonFilter_tt: 'Filtrar listado',

      buttonPrint: 'Imprimir',
      buttonPrint_tt: 'Imprimir en formato pdf',
      
      buttonLoadPieces: 'Usar Floor',
      buttonLoadPieces_tt: 'Cargar piezas seleccionándolas desde VS-Floor.',
      
      buttonLoadInventory: 'Usar Stock',
      buttonLoadInventory_tt: 'Cargar hoja seleccionando del material en stock.',

      buttonPrintSheets: 'Imprimir Gráficos',
      buttonPrintSheets_tt: 'Imprimir los gráficos resultantes de la optimización.',

      buttonPrintEasels: 'Imprimir Caballetes',
      buttonPrintEasels_tt: 'Imprimir los caballetes resultantes de la optimización.',

      buttonExport: 'Exportar',
      buttonExport_tt: 'Exportar la optimización a otro formato de fichero.',
      buttonBlock_bb: ' Para desbloquear esta funcionalidad contrate el servicio poniéndose en contacto con el administrador.',

      buttonNextGraphic: '>>',
      buttonNextGraphic_tt: 'Siguiente hoja',
      buttonBeforeGraphic: '<<',
      buttonBeforeGraphic_tt: 'Hoja anterior',
      buttonAllGraphic: 'Ver todas',
      buttonAllGraphic_tt: 'Ver todas las hojas',

      buttonRecharge: 'Recargar',
      buttonRecharge_tt: 'Recargar listado',

      buttonNewElement: '+',
      buttonNewElement_tt: 'Añadir nuevo elemento',

      buttonEdit: 'Editar',
      buttonEdit_tt: 'Editar elemento',

      buttonDelete: 'Eliminar',
      buttonDelete_tt: 'Eliminar elemento',

      buttonSave: 'Guardar',
      buttonSave_tt: 'Guardar modificaciones',

      buttonModify: 'Modificar',
      buttonModify_tt: 'Modificar elemento',

      buttonCancel: 'Cancelar',
      buttonCancel_tt: 'Cancelar acción',

      buttonConfirm: 'Confirmar',
      buttonConfirm_tt: 'Confirmar acción',
      
      buttonSelect: 'Seleccionar marcados',
      buttonSelect_tt: 'Seleccionar elementos marcados',

      buttonOptimizer: 'Optimizar',
      buttonOptimizer_tt: 'Optimizar archivos del directorio',

      buttonEmpty: 'Vaciar',
      buttonEmpty_tt: 'Vaciar elementos',

      // ----------------------
      // FILTROS
      // ----------------------
      filterText: 'Filtrar por ',
      filterSelectText: 'Elija ',
      filterNoActiveText: 'Incluir elementos no activos',

      // ---- Modal Mensajes Informativos
      modalInfoTitle: 'Mensaje informativo',
      modalOkInfo: 'La acción se ha realizado correctamente',

      // ----------------------
      //      ELEMENTOS
      // ----------------------
      itemNew: 'Nuevo',
      itemNewF: 'Nueva',
      itemNewP: 'Nuevos',
      itemAgent: 'Agente',
      itemAgentP: 'Agentes',
      itemClient: 'Cliente',
      itemClientP: 'Clientes',
      itemCuttingTable: 'Mesa de corte',
      itemCuttingTableP: 'Mesas de corte',
      itemBirth: 'Fecha de nacimiento',

      // ----------------------
      //      PESTAÑA PIEZA
      // ----------------------
      tabPiece: 'Piezas',
      tabSheet: 'Planchas',
      tabGraphic: 'Resultado',
      tabFile: 'Archivos',

      dtSelection: 'Seleccionar',

      dtBarcode: 'Codigo',
      dtClient: 'Cliente',
      dtDate: 'Fecha',
      dtDecoat: 'Dec.',
      dtVidrio: 'Vidrio',
      dtEasel: 'Caballete',
      dtFigure: 'Forma',
      dtFlip: 'Vuelta',
      dtGroup: 'Grupo',
      dtWidth: 'Ancho',
      dtHeight: 'Alto',
      dtIdClient: 'Id Cliente',
      dtIdLine: 'Line',
      dtLot: 'Lote',
      dtSequence: 'Sec.',
      dtMatId: 'Id Mat.',
      dtMatName: 'Material',
      dtMatDesc: 'Mat.Desc.',
      dtPriority: 'Prioridad',
      dtReference: 'Referencia',
      dtSteps: 'Pasos',
      dtStockLength: 'Long.Pila',
      dtUnits: 'Uds',
      dtOrderNo: 'Pedido',
      dtOrderPos: 'Línea',
      dtPacking: 'Embalaje',
      dtRoute: 'Ruta',
      dtB1: 'B1',
      dtB2: 'B2',
      dtB3: 'B3',
      dtB4: 'B4',
      dtH: 'H',
      dtH1: 'H1',
      dtH2: 'H2',
      dtL: 'L',
      dtL1: 'L1',
      dtL2: 'L2',
      dtR: 'R',
      dtR2: 'R2',
      dtR3: 'R3',
      dtR4: 'R4',

      // ----------------------
      //      PESTAÑA PLANCHA
      // ----------------------

      stWidth: 'Ancho',
      stHeight: 'Alto',
      stDepth: 'Espesor',
      stM2: 'M2',
      stMatId: 'Mat.Id',
      stMatName: 'Nombre',
      stMatDesc: 'Mat.Desc',
      stRetal: 'Retal',
      stReference: 'Referencia',
      stUnit: 'Uds',


      // ----------------------
      //      PESTAÑA ARCHIVOS
      // ----------------------

      arPiece: 'Entrada de piezas:',
      arSheet: 'Entrada de hojas:',

      arPieceName: 'Cargados para piezas',
      arSheetName: 'Cargados para hojas',

      // ------------------------------------------------
      //                  VENTANAS MODALES
      // ------------------------------------------------

      modalOptiSave: 'Datos de Optimización',
      modalOptiSave_tt: '¿Desea guardar los datos finales obtenidos en esta optimización?',
      modalOptiName_tt: 'Nombre&nbsp;descriptivo:',
      modalOptiName_ph: 'Nombre descriptivo',
      
      // ----------------------
      //   MODAL FORMAS PIEZA
      // ----------------------
      figureTitle: 'Edición de Forma: ',
      figureConfirm: 'Modificar forma',
      figureId: 'Id.&nbsp;Forma:&nbsp;',
      figureL: 'L',
      figureL1: 'L1',
      figureL2: 'L2',
      figureB1: 'B1',
      figureB2: 'B2',
      figureB3: 'B3',
      figureB4: 'B4',
      figureR: 'R',
      figureR2: 'R2',
      figureR3: 'R3',
      figureR4: 'R4',
      figureH: 'H',
      figureH1: 'H1',
      figureH2: 'H2',
      figureW: 'W',
      figureA1: 'A1',
      figureA2: 'A2',
      
      //
      
      floorBroken: 'Roturas',
      floorBroken_tt: 'Mostrar sólo las roturas.',
      floorPend: 'Pendientes',
      floorPend_tt: 'Cargar&nbsp;sólo&nbsp;pendientes:',

      // ------------------------------------------------
      //                  MAESTROS
      // ------------------------------------------------

    };

    this.vocabulary = vocabulary;

  } // End function constructor

} // End class LanguageEs
